module.exports = __webpack_public_path__ + "img/datacolor-paint.571dd0ac.png";